/** @format */
import COLORS from '../../../colors';

const CardBoxStyle = {
    cardBox: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.MAIN.DARK,
        color: COLORS.MAIN.LIGHT,
    },
    cardBoxContentPadding: {
        padding: '25px 15px 0 15px',
    },
    cardBoxTitle: {
        fontSize: 21,
        marginBottom: 15,
        fontWeight: 'bold',
    },
    cardBoxDescription: {
        fontWeight: 'bold',
    },
    cardBoxAction: {
        margin: '15px 0',
    },
};

export default CardBoxStyle;
